import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/src/element/common/closeSidemenu.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/ConfigProvider.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/CookieConsent.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/countUpOnlyOnce.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/customCursor.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/elmntbase.ts");
import(/* webpackMode: "eager" */ "/app/src/element/common/footcload.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/getSidemenuFlag.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/GoogleFontPreload.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/headcload.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/headerWrapper.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/image.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/imageModal.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/InstagramFeed.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/loader.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/navigation.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/NewsSocialShare.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/nvideo.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/openSidemenu.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/parallaxRotateBox.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/portfolioLoadMore.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/ProjectNavigation.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/RecaptchaProviderWrapper.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/scrolltotop.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/serviceDetail.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/sidemenuContentWrapper.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/sidemenuLinkWrapper.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/Slider.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/socialShareLink.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/sticky.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/videoModal.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/zoomOutOnScroll.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/typo3/form_formframework.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/typo3/news_newssearchform.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/typo3/pginate.tsx")